import Propositions from '@/views/rh/proposition_offre/pages/Proposition';
import Create from '@/views/rh/proposition_offre/pages/PropositionCreate';
import Edit from '@/views/rh/proposition_offre/pages/PropositionEdit';
import Show from '@/views/rh/proposition_offre/pages/PropositionShow';

export default [
  {
    path: '/rh/proposition-offre',
    name: 'rh_proposition_offre',
    component: Propositions,
    meta: {
      auth: true,
      module: 'rh',
      permission: 'access setting',
    },
  },
  {
    path: '/rh/proposition-offre/create/:cloneId?',
    name: 'rh_proposition_offre-create',
    component: Create,
    meta: {
      auth: true,
      module: 'rh',
      permission: 'access setting',
    },
  },
  {
    path: '/rh/proposition-offre/edit/:id',
    name: 'rh_proposition_offre-edit',
    component: Edit,
    meta: {
      auth: true,
      module: 'rh',
      permission: 'access setting',
    },
  },
  {
    path: '/rh/proposition-offre/show/:id',
    name: 'rh_proposition_offre-show',
    component: Show,
    meta: {
      auth: true,
      module: 'rh',
      permission: 'access setting',
    },
  },
];
